/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.13.2.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {optionsTransformer} from '@sekoia/shared/requests/nswagBaseClients/baseClient';
import * as moment from 'moment';

export class BaseClient {
  getBaseUrl(_: string, parsedBaseUrl: string | undefined): string {
    if (parsedBaseUrl) {
      return parsedBaseUrl;
    }

    if (!process.env.RECORDS_SERVICE_URL) {
      throw new Error('RECORDS_SERVICE_URL must be set in environment');
    }

    return process.env.RECORDS_SERVICE_URL;
  }
  
  async transformOptions(options: RequestInit) : Promise<RequestInit> {
    return optionsTransformer.addDefaultHeaders(options);
  }
}

export class RecordsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-records-dev.sekoia.one", baseUrl);
    }

    createRecord(request: CreateRecordRequest, residentId: string, signal?: AbortSignal | undefined): Promise<IdResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/records";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateRecord(_response);
        });
    }

    protected processCreateRecord(response: Response): Promise<IdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = IdResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdResponse>(<any>null);
    }

    getRecordsBySearch(residentId: string, recordQueryRequest: RecordQueryRequest, signal?: AbortSignal | undefined): Promise<GetRecordsPageResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/records/recordsSearch";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(recordQueryRequest);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRecordsBySearch(_response);
        });
    }

    protected processGetRecordsBySearch(response: Response): Promise<GetRecordsPageResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRecordsPageResponse.fromJS(resultData200);
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetRecordsPageResponse>(<any>null);
    }

    getAllRecordsWithinDateRange(request: RecordsForResidentsWithinDateRangeRequest, signal?: AbortSignal | undefined): Promise<RecordResponse[]> {
        let url_ = this.baseUrl + "/api/records/query";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetAllRecordsWithinDateRange(_response);
        });
    }

    protected processGetAllRecordsWithinDateRange(response: Response): Promise<RecordResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecordResponse[]>(<any>null);
    }

    deleteRecord(residentId: string, id: string, reason: string | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/records/{id}?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "Reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteRecord(_response);
        });
    }

    protected processDeleteRecord(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 410) {
            return response.text().then((_responseText) => {
            let result410: any = null;
            let resultData410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result410 = ProblemDetails.fromJS(resultData410);
            return throwException("A server side error occurred.", status, _responseText, _headers, result410);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    createComment(request: CreateCommentRequest, residentId: string, recordId: string, signal?: AbortSignal | undefined): Promise<IdResponse> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/records/{recordId}/comments";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (recordId === undefined || recordId === null)
            throw new Error("The parameter 'recordId' must be defined.");
        url_ = url_.replace("{recordId}", encodeURIComponent("" + recordId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            signal,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processCreateComment(_response);
        });
    }

    protected processCreateComment(response: Response): Promise<IdResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 201) {
            return response.text().then((_responseText) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = IdResponse.fromJS(resultData201);
            return result201;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            return throwException("A server side error occurred.", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<IdResponse>(<any>null);
    }

    deleteComment(residentId: string, recordId: string, id: string, reason: string | undefined, signal?: AbortSignal | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/records/{recordId}/comments/{id}?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (recordId === undefined || recordId === null)
            throw new Error("The parameter 'recordId' must be defined.");
        url_ = url_.replace("{recordId}", encodeURIComponent("" + recordId));
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (reason === null)
            throw new Error("The parameter 'reason' cannot be null.");
        else if (reason !== undefined)
            url_ += "Reason=" + encodeURIComponent("" + reason) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "DELETE",
            signal,
            headers: {
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processDeleteComment(_response);
        });
    }

    protected processDeleteComment(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 204) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 403) {
            return response.text().then((_responseText) => {
            let result403: any = null;
            let resultData403 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result403 = ProblemDetails.fromJS(resultData403);
            return throwException("A server side error occurred.", status, _responseText, _headers, result403);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 410) {
            return response.text().then((_responseText) => {
            let result410: any = null;
            let resultData410 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result410 = ProblemDetails.fromJS(resultData410);
            return throwException("A server side error occurred.", status, _responseText, _headers, result410);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    getRecordEntriesAffiliatedWithPlan(residentId: string, planId: string | undefined, signal?: AbortSignal | undefined): Promise<RecordEntryResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/recordsEntries?";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        if (planId === null)
            throw new Error("The parameter 'planId' cannot be null.");
        else if (planId !== undefined)
            url_ += "PlanId=" + encodeURIComponent("" + planId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetRecordEntriesAffiliatedWithPlan(_response);
        });
    }

    protected processGetRecordEntriesAffiliatedWithPlan(response: Response): Promise<RecordEntryResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RecordEntryResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecordEntryResponse[]>(<any>null);
    }
}

export class FormsClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = this.getBaseUrl("https://services-records-dev.sekoia.one", baseUrl);
    }

    getFormsForResident(residentId: string, signal?: AbortSignal | undefined): Promise<FormResponse[]> {
        let url_ = this.baseUrl + "/api/residents/{residentId}/records/forms";
        if (residentId === undefined || residentId === null)
            throw new Error("The parameter 'residentId' must be defined.");
        url_ = url_.replace("{residentId}", encodeURIComponent("" + residentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            signal,
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.processGetFormsForResident(_response);
        });
    }

    protected processGetFormsForResident(response: Response): Promise<FormResponse[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormResponse.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FormResponse[]>(<any>null);
    }
}

export class IdResponse implements IIdResponse {
    id!: string;

    constructor(data?: IIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): IdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data; 
    }
}

export interface IIdResponse {
    id: string;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions!: { [key: string]: any; };

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = this.extensions[key];
            }
        }
        return data; 
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };
}

export class CreateRecordRequest implements ICreateRecordRequest {
    entry!: string;
    planIds!: string[];
    observedAt!: moment.Moment;
    accessControlTagIds!: string[];
    categoryIds!: string[];

    constructor(data?: ICreateRecordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.planIds = [];
            this.accessControlTagIds = [];
            this.categoryIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entry = _data["entry"];
            if (Array.isArray(_data["planIds"])) {
                this.planIds = [] as any;
                for (let item of _data["planIds"])
                    this.planIds!.push(item);
            }
            this.observedAt = _data["observedAt"] ? moment(_data["observedAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entry"] = this.entry;
        if (Array.isArray(this.planIds)) {
            data["planIds"] = [];
            for (let item of this.planIds)
                data["planIds"].push(item);
        }
        data["observedAt"] = this.observedAt ? this.observedAt.toISOString() : <any>undefined;
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        return data; 
    }
}

export interface ICreateRecordRequest {
    entry: string;
    planIds: string[];
    observedAt: moment.Moment;
    accessControlTagIds: string[];
    categoryIds: string[];
}

export class GetRecordsPageResponse implements IGetRecordsPageResponse {
    records!: RecordResponse[];
    nextEntryTimeStamp?: moment.Moment | undefined;

    constructor(data?: IGetRecordsPageResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.records = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(RecordResponse.fromJS(item));
            }
            this.nextEntryTimeStamp = _data["nextEntryTimeStamp"] ? moment(_data["nextEntryTimeStamp"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): GetRecordsPageResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRecordsPageResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item.toJSON());
        }
        data["nextEntryTimeStamp"] = this.nextEntryTimeStamp ? this.nextEntryTimeStamp.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IGetRecordsPageResponse {
    records: RecordResponse[];
    nextEntryTimeStamp?: moment.Moment | undefined;
}

export class RecordResponse implements IRecordResponse {
    id!: string;
    residentId!: string;
    createdBy!: string;
    createdAt!: moment.Moment;
    isDeleted!: boolean;
    deletedBy?: string | undefined;
    deletedAt?: moment.Moment | undefined;
    deletedReason?: string | undefined;
    comments!: CommentResponse[];
    plans?: PlanResponse[] | undefined;
    categoryIds?: string[] | undefined;
    observedAt!: moment.Moment;
    accessControlTagIds!: string[];

    protected _discriminator: string;

    constructor(data?: IRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.comments = [];
            this.accessControlTagIds = [];
        }
        this._discriminator = "RecordResponse";
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.residentId = _data["residentId"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deletedBy = _data["deletedBy"];
            this.deletedAt = _data["deletedAt"] ? moment(_data["deletedAt"].toString()) : <any>undefined;
            this.deletedReason = _data["deletedReason"];
            if (Array.isArray(_data["comments"])) {
                this.comments = [] as any;
                for (let item of _data["comments"])
                    this.comments!.push(CommentResponse.fromJS(item));
            }
            if (Array.isArray(_data["plans"])) {
                this.plans = [] as any;
                for (let item of _data["plans"])
                    this.plans!.push(PlanResponse.fromJS(item));
            }
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
            this.observedAt = _data["observedAt"] ? moment(_data["observedAt"].toString()) : <any>undefined;
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
        }
    }

    static fromJS(data: any): RecordResponse {
        data = typeof data === 'object' ? data : {};
        if (data["discriminator"] === "RecordEntryResponse") {
            let result = new RecordEntryResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "FormRecordResponse") {
            let result = new FormRecordResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "PlanCreatedRecordResponse") {
            let result = new PlanCreatedRecordResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "PlanEndedRecordResponse") {
            let result = new PlanEndedRecordResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "PlanReopenedRecordResponse") {
            let result = new PlanReopenedRecordResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "PlanReviewedRecordResponse") {
            let result = new PlanReviewedRecordResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "HealthMeasurementRecordResponse") {
            let result = new HealthMeasurementRecordResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "TaskInstanceUpdateRecordResponse") {
            let result = new TaskInstanceUpdateRecordResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "TaskNotCompletedOnTimeRecordResponse") {
            let result = new TaskNotCompletedOnTimeRecordResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "AnamnesisRecordResponse") {
            let result = new AnamnesisRecordResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ResidentInformationRecordResponse") {
            let result = new ResidentInformationRecordResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "PnEffectRegistrationNotCompletedOnTimeRecordResponse") {
            let result = new PnEffectRegistrationNotCompletedOnTimeRecordResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "PnEffectRegistrationUpdatedRecordResponse") {
            let result = new PnEffectRegistrationUpdatedRecordResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "PnRegistrationUpdatedRecordResponse") {
            let result = new PnRegistrationUpdatedRecordResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "InternalContactRecordResponse") {
            let result = new InternalContactRecordResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "RecordsReportReadyRecordResponse") {
            let result = new RecordsReportReadyRecordResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "ResidentAddedToIncidentRecordResponse") {
            let result = new ResidentAddedToIncidentRecordResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "LendingPeriodStartedRecordResponse") {
            let result = new LendingPeriodStartedRecordResponse();
            result.init(data);
            return result;
        }
        if (data["discriminator"] === "LendingPeriodUpdatedRecordResponse") {
            let result = new LendingPeriodUpdatedRecordResponse();
            result.init(data);
            return result;
        }
        let result = new RecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["discriminator"] = this._discriminator; 
        data["id"] = this.id;
        data["residentId"] = this.residentId;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deletedBy"] = this.deletedBy;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>undefined;
        data["deletedReason"] = this.deletedReason;
        if (Array.isArray(this.comments)) {
            data["comments"] = [];
            for (let item of this.comments)
                data["comments"].push(item.toJSON());
        }
        if (Array.isArray(this.plans)) {
            data["plans"] = [];
            for (let item of this.plans)
                data["plans"].push(item.toJSON());
        }
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        data["observedAt"] = this.observedAt ? this.observedAt.toISOString() : <any>undefined;
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        return data; 
    }
}

export interface IRecordResponse {
    id: string;
    residentId: string;
    createdBy: string;
    createdAt: moment.Moment;
    isDeleted: boolean;
    deletedBy?: string | undefined;
    deletedAt?: moment.Moment | undefined;
    deletedReason?: string | undefined;
    comments: CommentResponse[];
    plans?: PlanResponse[] | undefined;
    categoryIds?: string[] | undefined;
    observedAt: moment.Moment;
    accessControlTagIds: string[];
}

export class CommentResponse implements ICommentResponse {
    id!: string;
    comment!: string;
    createdBy!: string;
    createdAt!: moment.Moment;
    isDeleted!: boolean;
    deletedBy?: string | undefined;
    deletedAt?: moment.Moment | undefined;
    deletedReason?: string | undefined;
    categoryIds!: string[];

    constructor(data?: ICommentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.categoryIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.comment = _data["comment"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? moment(_data["createdAt"].toString()) : <any>undefined;
            this.isDeleted = _data["isDeleted"];
            this.deletedBy = _data["deletedBy"];
            this.deletedAt = _data["deletedAt"] ? moment(_data["deletedAt"].toString()) : <any>undefined;
            this.deletedReason = _data["deletedReason"];
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CommentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CommentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["comment"] = this.comment;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["isDeleted"] = this.isDeleted;
        data["deletedBy"] = this.deletedBy;
        data["deletedAt"] = this.deletedAt ? this.deletedAt.toISOString() : <any>undefined;
        data["deletedReason"] = this.deletedReason;
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        return data; 
    }
}

export interface ICommentResponse {
    id: string;
    comment: string;
    createdBy: string;
    createdAt: moment.Moment;
    isDeleted: boolean;
    deletedBy?: string | undefined;
    deletedAt?: moment.Moment | undefined;
    deletedReason?: string | undefined;
    categoryIds: string[];
}

export class PlanResponse implements IPlanResponse {
    id!: string;
    accessControlTagIds!: string[];

    constructor(data?: IPlanResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.accessControlTagIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
        }
    }

    static fromJS(data: any): PlanResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlanResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        return data; 
    }
}

export interface IPlanResponse {
    id: string;
    accessControlTagIds: string[];
}

export class FormRecordResponse extends RecordResponse implements IFormRecordResponse {
    formRegistration!: any;

    constructor(data?: IFormRecordResponse) {
        super(data);
        this._discriminator = "FormRecordResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.formRegistration = _data["formRegistration"];
        }
    }

    static fromJS(data: any): FormRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formRegistration"] = this.formRegistration;
        super.toJSON(data);
        return data; 
    }
}

export interface IFormRecordResponse extends IRecordResponse {
    formRegistration: any;
}

export class RecordEntryResponse extends RecordResponse implements IRecordEntryResponse {
    entry!: string;

    constructor(data?: IRecordEntryResponse) {
        super(data);
        this._discriminator = "RecordEntryResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.entry = _data["entry"];
        }
    }

    static fromJS(data: any): RecordEntryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RecordEntryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entry"] = this.entry;
        super.toJSON(data);
        return data; 
    }
}

export interface IRecordEntryResponse extends IRecordResponse {
    entry: string;
}

export class PlanCreatedRecordResponse extends RecordResponse implements IPlanCreatedRecordResponse {
    planId!: string;

    constructor(data?: IPlanCreatedRecordResponse) {
        super(data);
        this._discriminator = "PlanCreatedRecordResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.planId = _data["planId"];
        }
    }

    static fromJS(data: any): PlanCreatedRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlanCreatedRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planId"] = this.planId;
        super.toJSON(data);
        return data; 
    }
}

export interface IPlanCreatedRecordResponse extends IRecordResponse {
    planId: string;
}

export class PlanEndedRecordResponse extends RecordResponse implements IPlanEndedRecordResponse {
    planId!: string;

    constructor(data?: IPlanEndedRecordResponse) {
        super(data);
        this._discriminator = "PlanEndedRecordResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.planId = _data["planId"];
        }
    }

    static fromJS(data: any): PlanEndedRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlanEndedRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planId"] = this.planId;
        super.toJSON(data);
        return data; 
    }
}

export interface IPlanEndedRecordResponse extends IRecordResponse {
    planId: string;
}

export class PlanReopenedRecordResponse extends RecordResponse implements IPlanReopenedRecordResponse {
    planId!: string;

    constructor(data?: IPlanReopenedRecordResponse) {
        super(data);
        this._discriminator = "PlanReopenedRecordResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.planId = _data["planId"];
        }
    }

    static fromJS(data: any): PlanReopenedRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlanReopenedRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planId"] = this.planId;
        super.toJSON(data);
        return data; 
    }
}

export interface IPlanReopenedRecordResponse extends IRecordResponse {
    planId: string;
}

export class PlanReviewedRecordResponse extends RecordResponse implements IPlanReviewedRecordResponse {
    planId!: string;
    evaluation?: string | undefined;

    constructor(data?: IPlanReviewedRecordResponse) {
        super(data);
        this._discriminator = "PlanReviewedRecordResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.planId = _data["planId"];
            this.evaluation = _data["evaluation"];
        }
    }

    static fromJS(data: any): PlanReviewedRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PlanReviewedRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planId"] = this.planId;
        data["evaluation"] = this.evaluation;
        super.toJSON(data);
        return data; 
    }
}

export interface IPlanReviewedRecordResponse extends IRecordResponse {
    planId: string;
    evaluation?: string | undefined;
}

export class HealthMeasurementRecordResponse extends RecordResponse implements IHealthMeasurementRecordResponse {
    healthMeasurement!: any;

    constructor(data?: IHealthMeasurementRecordResponse) {
        super(data);
        this._discriminator = "HealthMeasurementRecordResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.healthMeasurement = _data["healthMeasurement"];
        }
    }

    static fromJS(data: any): HealthMeasurementRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HealthMeasurementRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["healthMeasurement"] = this.healthMeasurement;
        super.toJSON(data);
        return data; 
    }
}

export interface IHealthMeasurementRecordResponse extends IRecordResponse {
    healthMeasurement: any;
}

export class TaskInstanceUpdateRecordResponse extends RecordResponse implements ITaskInstanceUpdateRecordResponse {
    taskInstanceUpdate!: TaskInstanceUpdateResponse;

    constructor(data?: ITaskInstanceUpdateRecordResponse) {
        super(data);
        if (!data) {
            this.taskInstanceUpdate = new TaskInstanceUpdateResponse();
        }
        this._discriminator = "TaskInstanceUpdateRecordResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.taskInstanceUpdate = _data["taskInstanceUpdate"] ? TaskInstanceUpdateResponse.fromJS(_data["taskInstanceUpdate"]) : new TaskInstanceUpdateResponse();
        }
    }

    static fromJS(data: any): TaskInstanceUpdateRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskInstanceUpdateRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskInstanceUpdate"] = this.taskInstanceUpdate ? this.taskInstanceUpdate.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface ITaskInstanceUpdateRecordResponse extends IRecordResponse {
    taskInstanceUpdate: TaskInstanceUpdateResponse;
}

export class TaskInstanceUpdateResponse implements ITaskInstanceUpdateResponse {
    residentId!: string;
    executedById!: string;
    timestamp!: moment.Moment;
    intervalStartTime?: moment.Moment | undefined;
    intervalEndTime?: moment.Moment | undefined;
    taskTitle!: string;
    reason?: string | undefined;
    taskInstanceId!: string;
    standardTaskId!: string;
    taskEntryId!: string;
    taskEventType!: TaskEventType;

    constructor(data?: ITaskInstanceUpdateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.residentId = _data["residentId"];
            this.executedById = _data["executedById"];
            this.timestamp = _data["timestamp"] ? moment(_data["timestamp"].toString()) : <any>undefined;
            this.intervalStartTime = _data["intervalStartTime"] ? moment(_data["intervalStartTime"].toString()) : <any>undefined;
            this.intervalEndTime = _data["intervalEndTime"] ? moment(_data["intervalEndTime"].toString()) : <any>undefined;
            this.taskTitle = _data["taskTitle"];
            this.reason = _data["reason"];
            this.taskInstanceId = _data["taskInstanceId"];
            this.standardTaskId = _data["standardTaskId"];
            this.taskEntryId = _data["taskEntryId"];
            this.taskEventType = _data["taskEventType"];
        }
    }

    static fromJS(data: any): TaskInstanceUpdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskInstanceUpdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residentId"] = this.residentId;
        data["executedById"] = this.executedById;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>undefined;
        data["intervalStartTime"] = this.intervalStartTime ? this.intervalStartTime.toISOString() : <any>undefined;
        data["intervalEndTime"] = this.intervalEndTime ? this.intervalEndTime.toISOString() : <any>undefined;
        data["taskTitle"] = this.taskTitle;
        data["reason"] = this.reason;
        data["taskInstanceId"] = this.taskInstanceId;
        data["standardTaskId"] = this.standardTaskId;
        data["taskEntryId"] = this.taskEntryId;
        data["taskEventType"] = this.taskEventType;
        return data; 
    }
}

export interface ITaskInstanceUpdateResponse {
    residentId: string;
    executedById: string;
    timestamp: moment.Moment;
    intervalStartTime?: moment.Moment | undefined;
    intervalEndTime?: moment.Moment | undefined;
    taskTitle: string;
    reason?: string | undefined;
    taskInstanceId: string;
    standardTaskId: string;
    taskEntryId: string;
    taskEventType: TaskEventType;
}

export enum TaskEventType {
    Completed = "Completed",
    CancelledCompletion = "CancelledCompletion",
    Cancelled = "Cancelled",
    Moved = "Moved",
    MovedTargetInfo = "MovedTargetInfo",
}

export class TaskNotCompletedOnTimeRecordResponse extends RecordResponse implements ITaskNotCompletedOnTimeRecordResponse {
    taskNotCompletedOnTime!: TaskNotCompletedOnTimeResponse;

    constructor(data?: ITaskNotCompletedOnTimeRecordResponse) {
        super(data);
        if (!data) {
            this.taskNotCompletedOnTime = new TaskNotCompletedOnTimeResponse();
        }
        this._discriminator = "TaskNotCompletedOnTimeRecordResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.taskNotCompletedOnTime = _data["taskNotCompletedOnTime"] ? TaskNotCompletedOnTimeResponse.fromJS(_data["taskNotCompletedOnTime"]) : new TaskNotCompletedOnTimeResponse();
        }
    }

    static fromJS(data: any): TaskNotCompletedOnTimeRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskNotCompletedOnTimeRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["taskNotCompletedOnTime"] = this.taskNotCompletedOnTime ? this.taskNotCompletedOnTime.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface ITaskNotCompletedOnTimeRecordResponse extends IRecordResponse {
    taskNotCompletedOnTime: TaskNotCompletedOnTimeResponse;
}

export class TaskNotCompletedOnTimeResponse implements ITaskNotCompletedOnTimeResponse {
    residentId!: string;
    taskTitle!: string;
    standardTaskId!: string;
    taskInstanceId!: string;
    intervalStartTime!: moment.Moment;
    intervalEndTime!: moment.Moment;

    constructor(data?: ITaskNotCompletedOnTimeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.residentId = _data["residentId"];
            this.taskTitle = _data["taskTitle"];
            this.standardTaskId = _data["standardTaskId"];
            this.taskInstanceId = _data["taskInstanceId"];
            this.intervalStartTime = _data["intervalStartTime"] ? moment(_data["intervalStartTime"].toString()) : <any>undefined;
            this.intervalEndTime = _data["intervalEndTime"] ? moment(_data["intervalEndTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): TaskNotCompletedOnTimeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TaskNotCompletedOnTimeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["residentId"] = this.residentId;
        data["taskTitle"] = this.taskTitle;
        data["standardTaskId"] = this.standardTaskId;
        data["taskInstanceId"] = this.taskInstanceId;
        data["intervalStartTime"] = this.intervalStartTime ? this.intervalStartTime.toISOString() : <any>undefined;
        data["intervalEndTime"] = this.intervalEndTime ? this.intervalEndTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface ITaskNotCompletedOnTimeResponse {
    residentId: string;
    taskTitle: string;
    standardTaskId: string;
    taskInstanceId: string;
    intervalStartTime: moment.Moment;
    intervalEndTime: moment.Moment;
}

export class AnamnesisRecordResponse extends RecordResponse implements IAnamnesisRecordResponse {
    oldValue?: AnamnesisResponse | undefined;
    newValue?: AnamnesisResponse | undefined;

    constructor(data?: IAnamnesisRecordResponse) {
        super(data);
        this._discriminator = "AnamnesisRecordResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.oldValue = _data["oldValue"] ? AnamnesisResponse.fromJS(_data["oldValue"]) : <any>undefined;
            this.newValue = _data["newValue"] ? AnamnesisResponse.fromJS(_data["newValue"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AnamnesisRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AnamnesisRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldValue"] = this.oldValue ? this.oldValue.toJSON() : <any>undefined;
        data["newValue"] = this.newValue ? this.newValue.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IAnamnesisRecordResponse extends IRecordResponse {
    oldValue?: AnamnesisResponse | undefined;
    newValue?: AnamnesisResponse | undefined;
}

export class AnamnesisResponse implements IAnamnesisResponse {
    contactReason?: string | undefined;
    healthHistory?: string | undefined;
    ongoingCare?: string | undefined;
    socialBackgroundAndLifestyle?: string | undefined;

    constructor(data?: IAnamnesisResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.contactReason = _data["contactReason"];
            this.healthHistory = _data["healthHistory"];
            this.ongoingCare = _data["ongoingCare"];
            this.socialBackgroundAndLifestyle = _data["socialBackgroundAndLifestyle"];
        }
    }

    static fromJS(data: any): AnamnesisResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AnamnesisResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["contactReason"] = this.contactReason;
        data["healthHistory"] = this.healthHistory;
        data["ongoingCare"] = this.ongoingCare;
        data["socialBackgroundAndLifestyle"] = this.socialBackgroundAndLifestyle;
        return data; 
    }
}

export interface IAnamnesisResponse {
    contactReason?: string | undefined;
    healthHistory?: string | undefined;
    ongoingCare?: string | undefined;
    socialBackgroundAndLifestyle?: string | undefined;
}

export class ResidentInformationRecordResponse extends RecordResponse implements IResidentInformationRecordResponse {
    oldValue!: ResidentInformationResponse;
    newValue!: ResidentInformationResponse;

    constructor(data?: IResidentInformationRecordResponse) {
        super(data);
        if (!data) {
            this.oldValue = new ResidentInformationResponse();
            this.newValue = new ResidentInformationResponse();
        }
        this._discriminator = "ResidentInformationRecordResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.oldValue = _data["oldValue"] ? ResidentInformationResponse.fromJS(_data["oldValue"]) : new ResidentInformationResponse();
            this.newValue = _data["newValue"] ? ResidentInformationResponse.fromJS(_data["newValue"]) : new ResidentInformationResponse();
        }
    }

    static fromJS(data: any): ResidentInformationRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResidentInformationRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldValue"] = this.oldValue ? this.oldValue.toJSON() : <any>undefined;
        data["newValue"] = this.newValue ? this.newValue.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IResidentInformationRecordResponse extends IRecordResponse {
    oldValue: ResidentInformationResponse;
    newValue: ResidentInformationResponse;
}

export class ResidentInformationResponse implements IResidentInformationResponse {
    firstname?: string | undefined;
    lastname?: string | undefined;
    displayName?: string | undefined;
    locationId?: number | undefined;
    ssn?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    note?: string | undefined;
    religion?: string | undefined;
    summaryOfKnownConditions?: string | undefined;
    resuscitationInstructions?: string | undefined;
    riskOfContamination?: string | undefined;
    medicalAllergies?: string | undefined;
    allergies?: string | undefined;
    maritalStatus?: string | undefined;
    residentStatus?: ResidentStatus | undefined;
    admission?: moment.Moment | undefined;
    discharge?: moment.Moment | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    nhsNumber?: string | undefined;
    niNumber?: string | undefined;
    sexualOrientation?: string | undefined;
    ethnicity?: string | undefined;
    pronouns?: string | undefined;
    doLS?: string | undefined;
    gender?: ResidentGender | undefined;
    personnummer?: string | undefined;
    flykting?: boolean | undefined;
    enpersonshushåll?: boolean | undefined;
    gallringsuntag?: boolean | undefined;
    skyddad?: boolean | undefined;
    samtyckerNationellaKvalitetsregister?: boolean | undefined;
    samtyckerBilder?: boolean | undefined;
    samtyckerOmsorgsdokumentation?: boolean | undefined;
    samtyckerVårdgivare?: boolean | undefined;
    identitetskontroll?: boolean | undefined;
    informationSomKanLedaTillSärskildVårdrutin?: string | undefined;
    kroniskeSygdommeOgHandicap?: string | undefined;
    samtykkekompetence?: string | undefined;
    diagnoser?: string | undefined;
    medicinadministrering?: string | undefined;

    constructor(data?: IResidentInformationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstname = _data["firstname"];
            this.lastname = _data["lastname"];
            this.displayName = _data["displayName"];
            this.locationId = _data["locationId"];
            this.ssn = _data["ssn"];
            this.dateOfBirth = _data["dateOfBirth"] ? moment(_data["dateOfBirth"].toString()) : <any>undefined;
            this.note = _data["note"];
            this.religion = _data["religion"];
            this.summaryOfKnownConditions = _data["summaryOfKnownConditions"];
            this.resuscitationInstructions = _data["resuscitationInstructions"];
            this.riskOfContamination = _data["riskOfContamination"];
            this.medicalAllergies = _data["medicalAllergies"];
            this.allergies = _data["allergies"];
            this.maritalStatus = _data["maritalStatus"];
            this.residentStatus = _data["residentStatus"];
            this.admission = _data["admission"] ? moment(_data["admission"].toString()) : <any>undefined;
            this.discharge = _data["discharge"] ? moment(_data["discharge"].toString()) : <any>undefined;
            this.email = _data["email"];
            this.phone = _data["phone"];
            this.nhsNumber = _data["nhsNumber"];
            this.niNumber = _data["niNumber"];
            this.sexualOrientation = _data["sexualOrientation"];
            this.ethnicity = _data["ethnicity"];
            this.pronouns = _data["pronouns"];
            this.doLS = _data["doLS"];
            this.gender = _data["gender"];
            this.personnummer = _data["personnummer"];
            this.flykting = _data["flykting"];
            this.enpersonshushåll = _data["enpersonshushåll"];
            this.gallringsuntag = _data["gallringsuntag"];
            this.skyddad = _data["skyddad"];
            this.samtyckerNationellaKvalitetsregister = _data["samtyckerNationellaKvalitetsregister"];
            this.samtyckerBilder = _data["samtyckerBilder"];
            this.samtyckerOmsorgsdokumentation = _data["samtyckerOmsorgsdokumentation"];
            this.samtyckerVårdgivare = _data["samtyckerVårdgivare"];
            this.identitetskontroll = _data["identitetskontroll"];
            this.informationSomKanLedaTillSärskildVårdrutin = _data["informationSomKanLedaTillSärskildVårdrutin"];
            this.kroniskeSygdommeOgHandicap = _data["kroniskeSygdommeOgHandicap"];
            this.samtykkekompetence = _data["samtykkekompetence"];
            this.diagnoser = _data["diagnoser"];
            this.medicinadministrering = _data["medicinadministrering"];
        }
    }

    static fromJS(data: any): ResidentInformationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResidentInformationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstname"] = this.firstname;
        data["lastname"] = this.lastname;
        data["displayName"] = this.displayName;
        data["locationId"] = this.locationId;
        data["ssn"] = this.ssn;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.format('YYYY-MM-DD') : <any>undefined;
        data["note"] = this.note;
        data["religion"] = this.religion;
        data["summaryOfKnownConditions"] = this.summaryOfKnownConditions;
        data["resuscitationInstructions"] = this.resuscitationInstructions;
        data["riskOfContamination"] = this.riskOfContamination;
        data["medicalAllergies"] = this.medicalAllergies;
        data["allergies"] = this.allergies;
        data["maritalStatus"] = this.maritalStatus;
        data["residentStatus"] = this.residentStatus;
        data["admission"] = this.admission ? this.admission.format('YYYY-MM-DD') : <any>undefined;
        data["discharge"] = this.discharge ? this.discharge.format('YYYY-MM-DD') : <any>undefined;
        data["email"] = this.email;
        data["phone"] = this.phone;
        data["nhsNumber"] = this.nhsNumber;
        data["niNumber"] = this.niNumber;
        data["sexualOrientation"] = this.sexualOrientation;
        data["ethnicity"] = this.ethnicity;
        data["pronouns"] = this.pronouns;
        data["doLS"] = this.doLS;
        data["gender"] = this.gender;
        data["personnummer"] = this.personnummer;
        data["flykting"] = this.flykting;
        data["enpersonshushåll"] = this.enpersonshushåll;
        data["gallringsuntag"] = this.gallringsuntag;
        data["skyddad"] = this.skyddad;
        data["samtyckerNationellaKvalitetsregister"] = this.samtyckerNationellaKvalitetsregister;
        data["samtyckerBilder"] = this.samtyckerBilder;
        data["samtyckerOmsorgsdokumentation"] = this.samtyckerOmsorgsdokumentation;
        data["samtyckerVårdgivare"] = this.samtyckerVårdgivare;
        data["identitetskontroll"] = this.identitetskontroll;
        data["informationSomKanLedaTillSärskildVårdrutin"] = this.informationSomKanLedaTillSärskildVårdrutin;
        data["kroniskeSygdommeOgHandicap"] = this.kroniskeSygdommeOgHandicap;
        data["samtykkekompetence"] = this.samtykkekompetence;
        data["diagnoser"] = this.diagnoser;
        data["medicinadministrering"] = this.medicinadministrering;
        return data; 
    }
}

export interface IResidentInformationResponse {
    firstname?: string | undefined;
    lastname?: string | undefined;
    displayName?: string | undefined;
    locationId?: number | undefined;
    ssn?: string | undefined;
    dateOfBirth?: moment.Moment | undefined;
    note?: string | undefined;
    religion?: string | undefined;
    summaryOfKnownConditions?: string | undefined;
    resuscitationInstructions?: string | undefined;
    riskOfContamination?: string | undefined;
    medicalAllergies?: string | undefined;
    allergies?: string | undefined;
    maritalStatus?: string | undefined;
    residentStatus?: ResidentStatus | undefined;
    admission?: moment.Moment | undefined;
    discharge?: moment.Moment | undefined;
    email?: string | undefined;
    phone?: string | undefined;
    nhsNumber?: string | undefined;
    niNumber?: string | undefined;
    sexualOrientation?: string | undefined;
    ethnicity?: string | undefined;
    pronouns?: string | undefined;
    doLS?: string | undefined;
    gender?: ResidentGender | undefined;
    personnummer?: string | undefined;
    flykting?: boolean | undefined;
    enpersonshushåll?: boolean | undefined;
    gallringsuntag?: boolean | undefined;
    skyddad?: boolean | undefined;
    samtyckerNationellaKvalitetsregister?: boolean | undefined;
    samtyckerBilder?: boolean | undefined;
    samtyckerOmsorgsdokumentation?: boolean | undefined;
    samtyckerVårdgivare?: boolean | undefined;
    identitetskontroll?: boolean | undefined;
    informationSomKanLedaTillSärskildVårdrutin?: string | undefined;
    kroniskeSygdommeOgHandicap?: string | undefined;
    samtykkekompetence?: string | undefined;
    diagnoser?: string | undefined;
    medicinadministrering?: string | undefined;
}

export enum ResidentStatus {
    None = "None",
    Active = "Active",
    PlannedAbsence = "PlannedAbsence",
    Hospitalized = "Hospitalized",
    Moved = "Moved",
    Deceased = "Deceased",
    PreAdmission = "PreAdmission",
    EndedEffort = "EndedEffort",
}

export enum ResidentGender {
    None = "None",
    Male = "Male",
    Female = "Female",
    NonBinary = "NonBinary",
}

export class PnEffectRegistrationNotCompletedOnTimeRecordResponse extends RecordResponse implements IPnEffectRegistrationNotCompletedOnTimeRecordResponse {
    pnEffectRegistrationNotCompletedOnTime!: PnEffectRegistrationNotCompletedOnTimeResponse;

    constructor(data?: IPnEffectRegistrationNotCompletedOnTimeRecordResponse) {
        super(data);
        if (!data) {
            this.pnEffectRegistrationNotCompletedOnTime = new PnEffectRegistrationNotCompletedOnTimeResponse();
        }
        this._discriminator = "PnEffectRegistrationNotCompletedOnTimeRecordResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pnEffectRegistrationNotCompletedOnTime = _data["pnEffectRegistrationNotCompletedOnTime"] ? PnEffectRegistrationNotCompletedOnTimeResponse.fromJS(_data["pnEffectRegistrationNotCompletedOnTime"]) : new PnEffectRegistrationNotCompletedOnTimeResponse();
        }
    }

    static fromJS(data: any): PnEffectRegistrationNotCompletedOnTimeRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnEffectRegistrationNotCompletedOnTimeRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pnEffectRegistrationNotCompletedOnTime"] = this.pnEffectRegistrationNotCompletedOnTime ? this.pnEffectRegistrationNotCompletedOnTime.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IPnEffectRegistrationNotCompletedOnTimeRecordResponse extends IRecordResponse {
    pnEffectRegistrationNotCompletedOnTime: PnEffectRegistrationNotCompletedOnTimeResponse;
}

export class PnEffectRegistrationNotCompletedOnTimeResponse implements IPnEffectRegistrationNotCompletedOnTimeResponse {
    pnEffectRegistrationId!: string;
    drugName!: string;
    strength!: string;
    form!: string;
    dosageUnit!: string;
    routeOfAdministration!: string;
    amount!: number;
    maxDosageQuantity?: number | undefined;
    startTime!: moment.Moment;
    endTime!: moment.Moment;

    constructor(data?: IPnEffectRegistrationNotCompletedOnTimeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pnEffectRegistrationId = _data["pnEffectRegistrationId"];
            this.drugName = _data["drugName"];
            this.strength = _data["strength"];
            this.form = _data["form"];
            this.dosageUnit = _data["dosageUnit"];
            this.routeOfAdministration = _data["routeOfAdministration"];
            this.amount = _data["amount"];
            this.maxDosageQuantity = _data["maxDosageQuantity"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PnEffectRegistrationNotCompletedOnTimeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnEffectRegistrationNotCompletedOnTimeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pnEffectRegistrationId"] = this.pnEffectRegistrationId;
        data["drugName"] = this.drugName;
        data["strength"] = this.strength;
        data["form"] = this.form;
        data["dosageUnit"] = this.dosageUnit;
        data["routeOfAdministration"] = this.routeOfAdministration;
        data["amount"] = this.amount;
        data["maxDosageQuantity"] = this.maxDosageQuantity;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IPnEffectRegistrationNotCompletedOnTimeResponse {
    pnEffectRegistrationId: string;
    drugName: string;
    strength: string;
    form: string;
    dosageUnit: string;
    routeOfAdministration: string;
    amount: number;
    maxDosageQuantity?: number | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment;
}

export class PnEffectRegistrationUpdatedRecordResponse extends RecordResponse implements IPnEffectRegistrationUpdatedRecordResponse {
    pnEffectRegistrationUpdated!: PnEffectRegistrationUpdatedResponse;

    constructor(data?: IPnEffectRegistrationUpdatedRecordResponse) {
        super(data);
        if (!data) {
            this.pnEffectRegistrationUpdated = new PnEffectRegistrationUpdatedResponse();
        }
        this._discriminator = "PnEffectRegistrationUpdatedRecordResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pnEffectRegistrationUpdated = _data["pnEffectRegistrationUpdated"] ? PnEffectRegistrationUpdatedResponse.fromJS(_data["pnEffectRegistrationUpdated"]) : new PnEffectRegistrationUpdatedResponse();
        }
    }

    static fromJS(data: any): PnEffectRegistrationUpdatedRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnEffectRegistrationUpdatedRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pnEffectRegistrationUpdated"] = this.pnEffectRegistrationUpdated ? this.pnEffectRegistrationUpdated.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IPnEffectRegistrationUpdatedRecordResponse extends IRecordResponse {
    pnEffectRegistrationUpdated: PnEffectRegistrationUpdatedResponse;
}

export class PnEffectRegistrationUpdatedResponse implements IPnEffectRegistrationUpdatedResponse {
    pnEffectRegistrationId!: string;
    drugName!: string;
    strength!: string;
    form!: string;
    dosageUnit!: string;
    routeOfAdministration!: string;
    amount!: number;
    effect?: string | undefined;
    maxDosageQuantity?: number | undefined;
    state!: HistoryState;
    reason?: string | undefined;
    startTime!: moment.Moment;
    endTime!: moment.Moment;

    constructor(data?: IPnEffectRegistrationUpdatedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pnEffectRegistrationId = _data["pnEffectRegistrationId"];
            this.drugName = _data["drugName"];
            this.strength = _data["strength"];
            this.form = _data["form"];
            this.dosageUnit = _data["dosageUnit"];
            this.routeOfAdministration = _data["routeOfAdministration"];
            this.amount = _data["amount"];
            this.effect = _data["effect"];
            this.maxDosageQuantity = _data["maxDosageQuantity"];
            this.state = _data["state"];
            this.reason = _data["reason"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PnEffectRegistrationUpdatedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnEffectRegistrationUpdatedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pnEffectRegistrationId"] = this.pnEffectRegistrationId;
        data["drugName"] = this.drugName;
        data["strength"] = this.strength;
        data["form"] = this.form;
        data["dosageUnit"] = this.dosageUnit;
        data["routeOfAdministration"] = this.routeOfAdministration;
        data["amount"] = this.amount;
        data["effect"] = this.effect;
        data["maxDosageQuantity"] = this.maxDosageQuantity;
        data["state"] = this.state;
        data["reason"] = this.reason;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IPnEffectRegistrationUpdatedResponse {
    pnEffectRegistrationId: string;
    drugName: string;
    strength: string;
    form: string;
    dosageUnit: string;
    routeOfAdministration: string;
    amount: number;
    effect?: string | undefined;
    maxDosageQuantity?: number | undefined;
    state: HistoryState;
    reason?: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment;
}

export enum HistoryState {
    Undefined = "Undefined",
    Undid = "Undid",
    Completed = "Completed",
    Cancelled = "Cancelled",
    Updated = "Updated",
}

export class PnRegistrationUpdatedRecordResponse extends RecordResponse implements IPnRegistrationUpdatedRecordResponse {
    pnRegistrationUpdated!: PnRegistrationUpdatedResponse;

    constructor(data?: IPnRegistrationUpdatedRecordResponse) {
        super(data);
        if (!data) {
            this.pnRegistrationUpdated = new PnRegistrationUpdatedResponse();
        }
        this._discriminator = "PnRegistrationUpdatedRecordResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pnRegistrationUpdated = _data["pnRegistrationUpdated"] ? PnRegistrationUpdatedResponse.fromJS(_data["pnRegistrationUpdated"]) : new PnRegistrationUpdatedResponse();
        }
    }

    static fromJS(data: any): PnRegistrationUpdatedRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnRegistrationUpdatedRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pnRegistrationUpdated"] = this.pnRegistrationUpdated ? this.pnRegistrationUpdated.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IPnRegistrationUpdatedRecordResponse extends IRecordResponse {
    pnRegistrationUpdated: PnRegistrationUpdatedResponse;
}

export class PnRegistrationUpdatedResponse implements IPnRegistrationUpdatedResponse {
    pnRegistrationId!: string;
    drugName!: string;
    strength!: string;
    form!: string;
    dosageUnit!: string;
    routeOfAdministration!: string;
    amount!: number;
    maxDosageQuantity?: number | undefined;
    state!: HistoryState;
    reason?: string | undefined;
    startTime!: moment.Moment;
    endTime!: moment.Moment;

    constructor(data?: IPnRegistrationUpdatedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pnRegistrationId = _data["pnRegistrationId"];
            this.drugName = _data["drugName"];
            this.strength = _data["strength"];
            this.form = _data["form"];
            this.dosageUnit = _data["dosageUnit"];
            this.routeOfAdministration = _data["routeOfAdministration"];
            this.amount = _data["amount"];
            this.maxDosageQuantity = _data["maxDosageQuantity"];
            this.state = _data["state"];
            this.reason = _data["reason"];
            this.startTime = _data["startTime"] ? moment(_data["startTime"].toString()) : <any>undefined;
            this.endTime = _data["endTime"] ? moment(_data["endTime"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): PnRegistrationUpdatedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PnRegistrationUpdatedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pnRegistrationId"] = this.pnRegistrationId;
        data["drugName"] = this.drugName;
        data["strength"] = this.strength;
        data["form"] = this.form;
        data["dosageUnit"] = this.dosageUnit;
        data["routeOfAdministration"] = this.routeOfAdministration;
        data["amount"] = this.amount;
        data["maxDosageQuantity"] = this.maxDosageQuantity;
        data["state"] = this.state;
        data["reason"] = this.reason;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>undefined;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>undefined;
        return data; 
    }
}

export interface IPnRegistrationUpdatedResponse {
    pnRegistrationId: string;
    drugName: string;
    strength: string;
    form: string;
    dosageUnit: string;
    routeOfAdministration: string;
    amount: number;
    maxDosageQuantity?: number | undefined;
    state: HistoryState;
    reason?: string | undefined;
    startTime: moment.Moment;
    endTime: moment.Moment;
}

export class InternalContactRecordResponse extends RecordResponse implements IInternalContactRecordResponse {
    oldValue?: InternalContactResponse | undefined;
    newValue?: InternalContactResponse | undefined;
    auditType!: AuditType;

    constructor(data?: IInternalContactRecordResponse) {
        super(data);
        this._discriminator = "InternalContactRecordResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.oldValue = _data["oldValue"] ? InternalContactResponse.fromJS(_data["oldValue"]) : <any>undefined;
            this.newValue = _data["newValue"] ? InternalContactResponse.fromJS(_data["newValue"]) : <any>undefined;
            this.auditType = _data["auditType"];
        }
    }

    static fromJS(data: any): InternalContactRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InternalContactRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldValue"] = this.oldValue ? this.oldValue.toJSON() : <any>undefined;
        data["newValue"] = this.newValue ? this.newValue.toJSON() : <any>undefined;
        data["auditType"] = this.auditType;
        super.toJSON(data);
        return data; 
    }
}

export interface IInternalContactRecordResponse extends IRecordResponse {
    oldValue?: InternalContactResponse | undefined;
    newValue?: InternalContactResponse | undefined;
    auditType: AuditType;
}

export class InternalContactResponse implements IInternalContactResponse {
    note?: string | undefined;
    relation?: string | undefined;
    employeeId?: string | undefined;

    constructor(data?: IInternalContactResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.note = _data["note"];
            this.relation = _data["relation"];
            this.employeeId = _data["employeeId"];
        }
    }

    static fromJS(data: any): InternalContactResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InternalContactResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["note"] = this.note;
        data["relation"] = this.relation;
        data["employeeId"] = this.employeeId;
        return data; 
    }
}

export interface IInternalContactResponse {
    note?: string | undefined;
    relation?: string | undefined;
    employeeId?: string | undefined;
}

export enum AuditType {
    None = "None",
    Create = "Create",
    Update = "Update",
    Delete = "Delete",
}

export class RecordsReportReadyRecordResponse extends RecordResponse implements IRecordsReportReadyRecordResponse {
    recordsReportReady!: RecordsReportReadyResponse;

    constructor(data?: IRecordsReportReadyRecordResponse) {
        super(data);
        if (!data) {
            this.recordsReportReady = new RecordsReportReadyResponse();
        }
        this._discriminator = "RecordsReportReadyRecordResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.recordsReportReady = _data["recordsReportReady"] ? RecordsReportReadyResponse.fromJS(_data["recordsReportReady"]) : new RecordsReportReadyResponse();
        }
    }

    static fromJS(data: any): RecordsReportReadyRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RecordsReportReadyRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["recordsReportReady"] = this.recordsReportReady ? this.recordsReportReady.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IRecordsReportReadyRecordResponse extends IRecordResponse {
    recordsReportReady: RecordsReportReadyResponse;
}

export class RecordsReportReadyResponse implements IRecordsReportReadyResponse {
    requisitionedBy!: string;
    requisitionedAt!: moment.Moment;
    requisitionReason!: string;
    reportTitle!: string;

    constructor(data?: IRecordsReportReadyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requisitionedBy = _data["requisitionedBy"];
            this.requisitionedAt = _data["requisitionedAt"] ? moment(_data["requisitionedAt"].toString()) : <any>undefined;
            this.requisitionReason = _data["requisitionReason"];
            this.reportTitle = _data["reportTitle"];
        }
    }

    static fromJS(data: any): RecordsReportReadyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RecordsReportReadyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requisitionedBy"] = this.requisitionedBy;
        data["requisitionedAt"] = this.requisitionedAt ? this.requisitionedAt.toISOString() : <any>undefined;
        data["requisitionReason"] = this.requisitionReason;
        data["reportTitle"] = this.reportTitle;
        return data; 
    }
}

export interface IRecordsReportReadyResponse {
    requisitionedBy: string;
    requisitionedAt: moment.Moment;
    requisitionReason: string;
    reportTitle: string;
}

export class ResidentAddedToIncidentRecordResponse extends RecordResponse implements IResidentAddedToIncidentRecordResponse {
    incident!: IncidentResponse;

    constructor(data?: IResidentAddedToIncidentRecordResponse) {
        super(data);
        if (!data) {
            this.incident = new IncidentResponse();
        }
        this._discriminator = "ResidentAddedToIncidentRecordResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.incident = _data["incident"] ? IncidentResponse.fromJS(_data["incident"]) : new IncidentResponse();
        }
    }

    static fromJS(data: any): ResidentAddedToIncidentRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ResidentAddedToIncidentRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["incident"] = this.incident ? this.incident.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface IResidentAddedToIncidentRecordResponse extends IRecordResponse {
    incident: IncidentResponse;
}

export class IncidentResponse implements IIncidentResponse {
    id!: number;
    incidentTemplateId!: string;
    incidentTemplateTitle!: string;

    constructor(data?: IIncidentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.incidentTemplateId = _data["incidentTemplateId"];
            this.incidentTemplateTitle = _data["incidentTemplateTitle"];
        }
    }

    static fromJS(data: any): IncidentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["incidentTemplateId"] = this.incidentTemplateId;
        data["incidentTemplateTitle"] = this.incidentTemplateTitle;
        return data; 
    }
}

export interface IIncidentResponse {
    id: number;
    incidentTemplateId: string;
    incidentTemplateTitle: string;
}

export class LendingPeriodStartedRecordResponse extends RecordResponse implements ILendingPeriodStartedRecordResponse {
    lendingPeriodStarted!: LendingPeriodStartedResponse;

    constructor(data?: ILendingPeriodStartedRecordResponse) {
        super(data);
        if (!data) {
            this.lendingPeriodStarted = new LendingPeriodStartedResponse();
        }
        this._discriminator = "LendingPeriodStartedRecordResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lendingPeriodStarted = _data["lendingPeriodStarted"] ? LendingPeriodStartedResponse.fromJS(_data["lendingPeriodStarted"]) : new LendingPeriodStartedResponse();
        }
    }

    static fromJS(data: any): LendingPeriodStartedRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LendingPeriodStartedRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lendingPeriodStarted"] = this.lendingPeriodStarted ? this.lendingPeriodStarted.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface ILendingPeriodStartedRecordResponse extends IRecordResponse {
    lendingPeriodStarted: LendingPeriodStartedResponse;
}

export class LendingPeriodStartedResponse implements ILendingPeriodStartedResponse {
    productCategoryId!: string;
    productTypeId!: string;
    productId!: string;
    inventoryItemId!: string;
    inventoryItemAssignedId!: string;
    lendingPeriodId!: string;
    startDate!: moment.Moment;
    endDate?: moment.Moment | undefined;
    accessoryDescription?: string | undefined;

    constructor(data?: ILendingPeriodStartedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCategoryId = _data["productCategoryId"];
            this.productTypeId = _data["productTypeId"];
            this.productId = _data["productId"];
            this.inventoryItemId = _data["inventoryItemId"];
            this.inventoryItemAssignedId = _data["inventoryItemAssignedId"];
            this.lendingPeriodId = _data["lendingPeriodId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.accessoryDescription = _data["accessoryDescription"];
        }
    }

    static fromJS(data: any): LendingPeriodStartedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LendingPeriodStartedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCategoryId"] = this.productCategoryId;
        data["productTypeId"] = this.productTypeId;
        data["productId"] = this.productId;
        data["inventoryItemId"] = this.inventoryItemId;
        data["inventoryItemAssignedId"] = this.inventoryItemAssignedId;
        data["lendingPeriodId"] = this.lendingPeriodId;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.format('YYYY-MM-DD') : <any>undefined;
        data["accessoryDescription"] = this.accessoryDescription;
        return data; 
    }
}

export interface ILendingPeriodStartedResponse {
    productCategoryId: string;
    productTypeId: string;
    productId: string;
    inventoryItemId: string;
    inventoryItemAssignedId: string;
    lendingPeriodId: string;
    startDate: moment.Moment;
    endDate?: moment.Moment | undefined;
    accessoryDescription?: string | undefined;
}

export class LendingPeriodUpdatedRecordResponse extends RecordResponse implements ILendingPeriodUpdatedRecordResponse {
    lendingPeriodUpdated!: LendingPeriodUpdatedResponse;

    constructor(data?: ILendingPeriodUpdatedRecordResponse) {
        super(data);
        if (!data) {
            this.lendingPeriodUpdated = new LendingPeriodUpdatedResponse();
        }
        this._discriminator = "LendingPeriodUpdatedRecordResponse";
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lendingPeriodUpdated = _data["lendingPeriodUpdated"] ? LendingPeriodUpdatedResponse.fromJS(_data["lendingPeriodUpdated"]) : new LendingPeriodUpdatedResponse();
        }
    }

    static fromJS(data: any): LendingPeriodUpdatedRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LendingPeriodUpdatedRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lendingPeriodUpdated"] = this.lendingPeriodUpdated ? this.lendingPeriodUpdated.toJSON() : <any>undefined;
        super.toJSON(data);
        return data; 
    }
}

export interface ILendingPeriodUpdatedRecordResponse extends IRecordResponse {
    lendingPeriodUpdated: LendingPeriodUpdatedResponse;
}

export class LendingPeriodUpdatedResponse implements ILendingPeriodUpdatedResponse {
    productCategoryId!: string;
    productTypeId!: string;
    productId!: string;
    inventoryItemId!: string;
    inventoryItemAssignedId!: string;
    lendingPeriodId!: string;
    startDate!: moment.Moment;
    endDate?: moment.Moment | undefined;
    accessoryDescription?: string | undefined;

    constructor(data?: ILendingPeriodUpdatedResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.productCategoryId = _data["productCategoryId"];
            this.productTypeId = _data["productTypeId"];
            this.productId = _data["productId"];
            this.inventoryItemId = _data["inventoryItemId"];
            this.inventoryItemAssignedId = _data["inventoryItemAssignedId"];
            this.lendingPeriodId = _data["lendingPeriodId"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            this.accessoryDescription = _data["accessoryDescription"];
        }
    }

    static fromJS(data: any): LendingPeriodUpdatedResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LendingPeriodUpdatedResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["productCategoryId"] = this.productCategoryId;
        data["productTypeId"] = this.productTypeId;
        data["productId"] = this.productId;
        data["inventoryItemId"] = this.inventoryItemId;
        data["inventoryItemAssignedId"] = this.inventoryItemAssignedId;
        data["lendingPeriodId"] = this.lendingPeriodId;
        data["startDate"] = this.startDate ? this.startDate.format('YYYY-MM-DD') : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.format('YYYY-MM-DD') : <any>undefined;
        data["accessoryDescription"] = this.accessoryDescription;
        return data; 
    }
}

export interface ILendingPeriodUpdatedResponse {
    productCategoryId: string;
    productTypeId: string;
    productId: string;
    inventoryItemId: string;
    inventoryItemAssignedId: string;
    lendingPeriodId: string;
    startDate: moment.Moment;
    endDate?: moment.Moment | undefined;
    accessoryDescription?: string | undefined;
}

export class RecordQueryRequest implements IRecordQueryRequest {
    countToTake?: number | undefined;
    nextEntryTimeStamp!: moment.Moment;
    searchText?: string | undefined;
    planIds?: string[] | undefined;
    accessControlTagIds?: string[] | undefined;
    formIds?: string[] | undefined;
    incidentTemplateIds?: string[] | undefined;
    healthMeasurementTypes?: string[] | undefined;
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    recordSearchTypes?: RecordSearchType[] | undefined;
    categories?: string[][] | undefined;

    constructor(data?: IRecordQueryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countToTake = _data["countToTake"];
            this.nextEntryTimeStamp = _data["nextEntryTimeStamp"] ? moment(_data["nextEntryTimeStamp"].toString()) : <any>undefined;
            this.searchText = _data["searchText"];
            if (Array.isArray(_data["planIds"])) {
                this.planIds = [] as any;
                for (let item of _data["planIds"])
                    this.planIds!.push(item);
            }
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            if (Array.isArray(_data["formIds"])) {
                this.formIds = [] as any;
                for (let item of _data["formIds"])
                    this.formIds!.push(item);
            }
            if (Array.isArray(_data["incidentTemplateIds"])) {
                this.incidentTemplateIds = [] as any;
                for (let item of _data["incidentTemplateIds"])
                    this.incidentTemplateIds!.push(item);
            }
            if (Array.isArray(_data["healthMeasurementTypes"])) {
                this.healthMeasurementTypes = [] as any;
                for (let item of _data["healthMeasurementTypes"])
                    this.healthMeasurementTypes!.push(item);
            }
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["recordSearchTypes"])) {
                this.recordSearchTypes = [] as any;
                for (let item of _data["recordSearchTypes"])
                    this.recordSearchTypes!.push(item);
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
        }
    }

    static fromJS(data: any): RecordQueryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RecordQueryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countToTake"] = this.countToTake;
        data["nextEntryTimeStamp"] = this.nextEntryTimeStamp ? this.nextEntryTimeStamp.toISOString() : <any>undefined;
        data["searchText"] = this.searchText;
        if (Array.isArray(this.planIds)) {
            data["planIds"] = [];
            for (let item of this.planIds)
                data["planIds"].push(item);
        }
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        if (Array.isArray(this.formIds)) {
            data["formIds"] = [];
            for (let item of this.formIds)
                data["formIds"].push(item);
        }
        if (Array.isArray(this.incidentTemplateIds)) {
            data["incidentTemplateIds"] = [];
            for (let item of this.incidentTemplateIds)
                data["incidentTemplateIds"].push(item);
        }
        if (Array.isArray(this.healthMeasurementTypes)) {
            data["healthMeasurementTypes"] = [];
            for (let item of this.healthMeasurementTypes)
                data["healthMeasurementTypes"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.recordSearchTypes)) {
            data["recordSearchTypes"] = [];
            for (let item of this.recordSearchTypes)
                data["recordSearchTypes"].push(item);
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        return data; 
    }
}

export interface IRecordQueryRequest {
    countToTake?: number | undefined;
    nextEntryTimeStamp: moment.Moment;
    searchText?: string | undefined;
    planIds?: string[] | undefined;
    accessControlTagIds?: string[] | undefined;
    formIds?: string[] | undefined;
    incidentTemplateIds?: string[] | undefined;
    healthMeasurementTypes?: string[] | undefined;
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    recordSearchTypes?: RecordSearchType[] | undefined;
    categories?: string[][] | undefined;
}

export enum RecordSearchType {
    Tasks = "Tasks",
    Plans = "Plans",
    Forms = "Forms",
    HealthMeasurements = "HealthMeasurements",
    ResidentProfile = "ResidentProfile",
    Entries = "Entries",
    Incidents = "Incidents",
    Inventory = "Inventory",
}

export class RecordsForResidentsWithinDateRangeRequest implements IRecordsForResidentsWithinDateRangeRequest {
    searchText?: string | undefined;
    planIds?: string[] | undefined;
    formIds?: string[] | undefined;
    incidentTemplateIds?: string[] | undefined;
    accessControlTagIds?: string[] | undefined;
    healthMeasurementTypes?: string[] | undefined;
    residentIds!: string[];
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    recordSearchTypes?: RecordSearchType[] | undefined;
    categories?: string[][] | undefined;

    constructor(data?: IRecordsForResidentsWithinDateRangeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.residentIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
            if (Array.isArray(_data["planIds"])) {
                this.planIds = [] as any;
                for (let item of _data["planIds"])
                    this.planIds!.push(item);
            }
            if (Array.isArray(_data["formIds"])) {
                this.formIds = [] as any;
                for (let item of _data["formIds"])
                    this.formIds!.push(item);
            }
            if (Array.isArray(_data["incidentTemplateIds"])) {
                this.incidentTemplateIds = [] as any;
                for (let item of _data["incidentTemplateIds"])
                    this.incidentTemplateIds!.push(item);
            }
            if (Array.isArray(_data["accessControlTagIds"])) {
                this.accessControlTagIds = [] as any;
                for (let item of _data["accessControlTagIds"])
                    this.accessControlTagIds!.push(item);
            }
            if (Array.isArray(_data["healthMeasurementTypes"])) {
                this.healthMeasurementTypes = [] as any;
                for (let item of _data["healthMeasurementTypes"])
                    this.healthMeasurementTypes!.push(item);
            }
            if (Array.isArray(_data["residentIds"])) {
                this.residentIds = [] as any;
                for (let item of _data["residentIds"])
                    this.residentIds!.push(item);
            }
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : <any>undefined;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : <any>undefined;
            if (Array.isArray(_data["recordSearchTypes"])) {
                this.recordSearchTypes = [] as any;
                for (let item of _data["recordSearchTypes"])
                    this.recordSearchTypes!.push(item);
            }
            if (Array.isArray(_data["categories"])) {
                this.categories = [] as any;
                for (let item of _data["categories"])
                    this.categories!.push(item);
            }
        }
    }

    static fromJS(data: any): RecordsForResidentsWithinDateRangeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new RecordsForResidentsWithinDateRangeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        if (Array.isArray(this.planIds)) {
            data["planIds"] = [];
            for (let item of this.planIds)
                data["planIds"].push(item);
        }
        if (Array.isArray(this.formIds)) {
            data["formIds"] = [];
            for (let item of this.formIds)
                data["formIds"].push(item);
        }
        if (Array.isArray(this.incidentTemplateIds)) {
            data["incidentTemplateIds"] = [];
            for (let item of this.incidentTemplateIds)
                data["incidentTemplateIds"].push(item);
        }
        if (Array.isArray(this.accessControlTagIds)) {
            data["accessControlTagIds"] = [];
            for (let item of this.accessControlTagIds)
                data["accessControlTagIds"].push(item);
        }
        if (Array.isArray(this.healthMeasurementTypes)) {
            data["healthMeasurementTypes"] = [];
            for (let item of this.healthMeasurementTypes)
                data["healthMeasurementTypes"].push(item);
        }
        if (Array.isArray(this.residentIds)) {
            data["residentIds"] = [];
            for (let item of this.residentIds)
                data["residentIds"].push(item);
        }
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>undefined;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>undefined;
        if (Array.isArray(this.recordSearchTypes)) {
            data["recordSearchTypes"] = [];
            for (let item of this.recordSearchTypes)
                data["recordSearchTypes"].push(item);
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item);
        }
        return data; 
    }
}

export interface IRecordsForResidentsWithinDateRangeRequest {
    searchText?: string | undefined;
    planIds?: string[] | undefined;
    formIds?: string[] | undefined;
    incidentTemplateIds?: string[] | undefined;
    accessControlTagIds?: string[] | undefined;
    healthMeasurementTypes?: string[] | undefined;
    residentIds: string[];
    startDate?: moment.Moment | undefined;
    endDate?: moment.Moment | undefined;
    recordSearchTypes?: RecordSearchType[] | undefined;
    categories?: string[][] | undefined;
}

export class CreateCommentRequest implements ICreateCommentRequest {
    comment!: string;
    categoryIds!: string[];

    constructor(data?: ICreateCommentRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.categoryIds = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.comment = _data["comment"];
            if (Array.isArray(_data["categoryIds"])) {
                this.categoryIds = [] as any;
                for (let item of _data["categoryIds"])
                    this.categoryIds!.push(item);
            }
        }
    }

    static fromJS(data: any): CreateCommentRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateCommentRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["comment"] = this.comment;
        if (Array.isArray(this.categoryIds)) {
            data["categoryIds"] = [];
            for (let item of this.categoryIds)
                data["categoryIds"].push(item);
        }
        return data; 
    }
}

export interface ICreateCommentRequest {
    comment: string;
    categoryIds: string[];
}

export class FormResponse implements IFormResponse {
    id!: string;
    formTitle!: string;

    constructor(data?: IFormResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formTitle = _data["formTitle"];
        }
    }

    static fromJS(data: any): FormResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FormResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formTitle"] = this.formTitle;
        return data; 
    }
}

export interface IFormResponse {
    id: string;
    formTitle: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}